export default __webpack_public_path__ + "static/media/plt3.0df3ef3f.png";